import { CurrentToolbarUpdatedAction, CurrentToolbarActionType } from './currentToolbarActions';
import { ToolbarState } from './toolbarTypes';

export type CurrentToolbarReducerState = ToolbarState | null;

export default (state = null, action: CurrentToolbarUpdatedAction) => {
    switch (action.type) {
        case CurrentToolbarActionType.TOOLBAR_STATE_UPDATE:
            return action.toolbarState;
        default:
            return state;
    }
};
